import { render } from "./AssignCategory.vue?vue&type=template&id=fe996b44&scoped=true"
import script from "./AssignCategory.vue?vue&type=script&lang=js"
export * from "./AssignCategory.vue?vue&type=script&lang=js"

import "./AssignCategory.vue?vue&type=style&index=0&id=fe996b44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe996b44"]])

export default __exports__